export const globalDealSettingsKeysToUpdate = [
  "projectId",
  "customerOpportunityGroupId",
  "customerOpportunityGroupName",
  "leadCustomerItsmId",
];

export interface GlobalDealSettingsModel {
  id?: string;
  projectId?: string;
  globalOpportunityId?: string;
  opportunityDesc?: string;
  globalOpportunityDesc?: string;
  customerOpportunityGroupId?: string;
  customerOpportunityGroupName?: string;
  leadCustomerName?: string;
  leadCustomerBpid?: string;
  leadCustomerItsmId?: string;
  mpcAccountId?: string;
}

export function globalDealSettingsModelFactory(json?: any): GlobalDealSettingsModel {
  json = json || {};

  return {
    id: json.id || "",
    projectId: json.projectId || "",
    globalOpportunityId: json.globalOpportunityId || "",
    opportunityDesc: json.opportunityDesc || "",
    globalOpportunityDesc: json.globalOpportunityDesc || "",
    customerOpportunityGroupId: json.customerOpportunityGroupId || "",
    customerOpportunityGroupName: json.customerOpportunityGroupName || "",
    leadCustomerName: json.leadCustomerName || "",
    leadCustomerBpid: json.leadCustomerBpid || "",
    leadCustomerItsmId: json.leadCustomerItsmId || "",
    mpcAccountId: json.mpcAccountId || "",
  };
}
